import { render, staticRenderFns } from "./AddressProofFiles.vue?vue&type=template&id=52650cfb"
import script from "./AddressProofFiles.vue?vue&type=script&lang=js"
export * from "./AddressProofFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports